import React from "react";
import { DisclaimersContainer } from "../components/disclaimers/DisclaimersContainer";
import { FootnotesContainer } from "../components/footnotes/FootnotesContainer";
import { Warnings } from "../components/warnings/Warnings";
import { SearchResultsFactory } from "./table/SearchResultsFactory";
import { resultTableConfigType } from "../../common/types/search/results";
import {
	additionalSearchLinkType,
	contentCreditsType,
	footnoteSingleType,
	footnotesType,
	pagingType,
	warningsType,
} from "../../common/types/search/search";
import Disclaimers from "../components/disclaimers/Disclaimers";

interface SearchResultsProps {
	additionalSearchLink?: additionalSearchLinkType;
	contentCredits?: contentCreditsType;
	disclaimers?: Disclaimers;
	footnotes?: footnotesType;
	footnoteSingle?: footnoteSingleType;
	paging: pagingType;
	resultTableConfig: resultTableConfigType;
	warnings?: warningsType;
}

export function SearchResults({
	additionalSearchLink,
	contentCredits,
	disclaimers,
	footnotes,
	footnoteSingle,
	paging,
	resultTableConfig,
	warnings,
}: SearchResultsProps) {
	return (
		<>
			<Warnings warnings={warnings} />
			<SearchResultsFactory
				footnotes={footnotes}
				resultTableConfig={resultTableConfig}
				paging={paging}
			/>
			{additionalSearchLink}
			{footnoteSingle}
			<DisclaimersContainer disclaimers={disclaimers} />
			{contentCredits}
			<FootnotesContainer footnotes={footnotes} />
		</>
	);
}
